import React, { useEffect } from 'react'

interface SEOProps {
    title: string
    description?: string
    image?: string
    url?: string
}

const SEO: React.FC<SEOProps> = ({ title, description, image, url }) => {
    useEffect(() => {
        // Update title
        const previousTitle = document.title
        document.title = `${title} | BaterPower`

        // Update meta tags
        updateMeta('description', description)
        updateMeta('og:title', title)
        updateMeta('og:description', description)
        updateMeta('og:image', image)
        updateMeta('og:url', url)
        updateMeta('twitter:title', title)
        updateMeta('twitter:description', description)
        updateMeta('twitter:image', image)

        return () => {
            document.title = previousTitle
        }
    }, [title, description, image, url])

    return null
}

const updateMeta = (name: string, content?: string) => {
    if (!content) return

    let element = document.querySelector(`meta[name="${name}"]`) || document.querySelector(`meta[property="${name}"]`)

    if (!element) {
        element = document.createElement('meta')
        if (name.startsWith('og:')) {
            element.setAttribute('property', name)
        } else {
            element.setAttribute('name', name)
        }
        document.head.appendChild(element)
    }

    element.setAttribute('content', content)
}

export default SEO

